import { Button, TableColumnHeaderProps, Text, Th } from '@chakra-ui/react'
import React from 'react'
import SortIcons from '../SortIcons/SortIcons'

interface ColumnHeaderProps extends TableColumnHeaderProps {
  label: string
  isSortingBy?: boolean
  sortAscending?: boolean
  onClick?: () => void
  width?: number | string
  isNumeric?: boolean
  isCentered?: boolean
  isSortable: boolean
}

const ColumnHeader = ({
  label,
  isSortable,
  isSortingBy = false,
  sortAscending = false,
  onClick = () => {},
  width,
  isNumeric,
  isCentered,
  ...restProps
}: ColumnHeaderProps) => (
  <Th
    bg="gray.100"
    textTransform="none"
    borderBottomColor="gray.500"
    minWidth={width}
    width={width}
    maxWidth={width}
    role="columnheader"
    scope="col"
    {...(isSortingBy && {
      'aria-sort': sortAscending ? 'ascending' : 'descending',
    })}
    p={0}
    isNumeric={isNumeric}
    {...restProps}
  >
    {isSortable ? (
      <Button
        border="0"
        variant="ghost"
        _hover={{ background: 'transparent' }}
        _active={{ background: 'transparent' }}
        onClick={onClick}
        size="sm"
        w="100%"
        padding=".5rem"
        fontWeight="500"
        flexDirection={isNumeric ? 'row-reverse' : 'row'}
        justifyContent={isCentered ? 'center' : 'normal'}
      >
        <Text isTruncated>{label}</Text>
        <SortIcons
          ascending={sortAscending}
          isSortingBy={isSortingBy}
          display={!isSortingBy && isCentered ? 'none' : 'inherit'}
        />
      </Button>
    ) : (
      <Text isTruncated fontWeight="500" p=".5rem">
        {label}
      </Text>
    )}
  </Th>
)

export default ColumnHeader
